/**
 * Converts raw number, string, or Date to a Date object.
 */
const parseToDate = (date) => {
    const dateStringValue = String(date);
    // Check if input is a raw UNIX timestamp (must convert to Date)
    if (dateStringValue.match(/^\d{10}$|^\d{13}$/)) {
        const timestamp = dateStringValue.length === 10
            ? Number(date) * 1000 // Convert the timestamp from seconds to milliseconds
            : Number(date);
        return new Date(timestamp);
    }
    try {
        return new Date(date);
    }
    catch (error) {
        return null;
    }
};
/**
 * Formats a Date object to a string in YYYY/MM/DD format.
 * The glue string is the separator between year, month and day.
 */
const dateFormatter = (date, glue) => `${date.getFullYear()}${glue}${(`0${date.getMonth() + 1}`).slice(-2)}${glue}${(`0${date.getDate()}`).slice(-2)}`;
/**
 * Corrct the offset of a Date object to UTC.
 */
const convertToUtc = (date) => {
    const dateValue = new Date(date);
    dateValue.setMinutes(dateValue.getMinutes() + dateValue.getTimezoneOffset());
    return dateValue;
};
/**
 * Convert a Date object to the thn string format yyyy/mm/dd.
 * @param [utc=true] - Denotes if the date is in UTC.
 * @param [glue='/'] - The glue string between year, month and day.
 */
const dateToString = (date, utc = true, glue = '/') => {
    const parsedDate = parseToDate(date);
    // Invalid date
    if (!parsedDate || Number.isNaN(parsedDate.getTime())) {
        return null;
    }
    if (!utc) {
        return dateFormatter(parsedDate, glue);
    }
    const utcDate = convertToUtc(parsedDate);
    return dateFormatter(utcDate, glue);
};

/**
 * Calc the difference between dates, in days.
 *
 * @param {number|string} rawArrival - a date
 * @param {number|string} rawDeparture - a date
 * @return {number} - Number of days between both dates.
 */
function daysBetween(rawArrival, rawDeparture) {
    let parts;
    let parsedArrival;
    let parsedDeparture;
    let rawArrivalParam = rawArrival;
    let rawDepartureParam = rawDeparture;
    if (typeof rawArrival === 'number') {
        rawArrivalParam = String(rawArrivalParam);
    }
    if (typeof rawDeparture === 'number') {
        rawDepartureParam = String(rawDepartureParam);
    }
    if (typeof rawArrivalParam === 'string') {
        parts = rawArrivalParam.substring(0, 10).split(/[/-]/).map(el => Number(el));
        // it is a THN date string yyyy/mm/dd
        if (parts.length > 2) {
            parsedArrival = new Date(parts[0], parts[1] - 1, parts[2]);
        }
        else { // unixtimestamp
            parts = rawArrivalParam.match(/^\d{10}/)?.map(el => parseInt(el, 10)) || [];
            if (parts?.length) {
                parsedArrival = new Date(parts[0] * 1000);
            }
        }
    }
    else if (rawArrivalParam instanceof Date) {
        // Copy date parts of the timestamps, discarding the time parts.
        parsedArrival = new Date(rawArrivalParam.getFullYear(), rawArrivalParam.getMonth(), rawArrivalParam.getDate());
    }
    if (typeof rawDepartureParam === 'string') {
        parts = rawDepartureParam.substring(0, 10).split(/[/-]/).map(el => Number(el));
        // it is a THN date string yyyy/mm/dd
        if (parts.length > 2) {
            parsedDeparture = new Date(parts[0], parts[1] - 1, parts[2]);
        }
        else { // unixtimestamp
            parts = rawDepartureParam.match(/^\d{10}/)?.map(el => parseInt(el, 10)) || [];
            if (parts?.length) {
                parsedDeparture = new Date(parts[0] * 1000);
            }
        }
    }
    else if (rawDepartureParam instanceof Date) {
        // Copy date parts of the timestamps, discarding the time parts.
        parsedDeparture = new Date(rawDepartureParam.getFullYear(), rawDepartureParam.getMonth(), rawDepartureParam.getDate());
    }
    // Do the math.
    const millirawDeparturesPerDay = 1000 * 60 * 60 * 24;
    if (!parsedArrival || !parsedDeparture) {
        throw new Error('Unable to parse dates.');
    }
    // correct offsets: in case they are in a diferent DST
    parsedArrival.setMinutes(parsedArrival.getMinutes() - parsedArrival.getTimezoneOffset());
    parsedDeparture.setMinutes(parsedDeparture.getMinutes() - parsedDeparture.getTimezoneOffset());
    // diff
    const millisBetween = parsedDeparture.getTime() - parsedArrival.getTime();
    const days = millisBetween / millirawDeparturesPerDay;
    // Use round to avoid some timezone errors in the JS engine
    // (for instance Brazil/East on DST)
    return Math.round(days);
}

export { daysBetween as a, dateToString as d };
